<script setup lang="ts">
// Corner-brackets outline — area / size. Colour follows CSS `color`.
defineOptions({ inheritAttrs: false })
</script>

<template>
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    v-bind="$attrs"
  >
    <path
      d="M4.66667 1.75H2.91667C2.60725 1.75 2.3105 1.87292 2.09171 2.09171C1.87292 2.3105 1.75 2.60725 1.75 2.91667V4.66667"
      stroke-width="1.16667"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke="currentColor"
    />
    <path
      d="M12.25 4.66667V2.91667C12.25 2.60725 12.1271 2.3105 11.9083 2.09171C11.6895 1.87292 11.3928 1.75 11.0833 1.75H9.33333"
      stroke-width="1.16667"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke="currentColor"
    />
    <path
      d="M1.75 9.33333V11.0833C1.75 11.3928 1.87292 11.6895 2.09171 11.9083C2.3105 12.1271 2.60725 12.25 2.91667 12.25H4.66667"
      stroke-width="1.16667"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke="currentColor"
    />
    <path
      d="M9.33333 12.25H11.0833C11.3928 12.25 11.6895 12.1271 11.9083 11.9083C12.1271 11.6895 12.25 11.3928 12.25 11.0833V9.33333"
      stroke-width="1.16667"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke="currentColor"
    />
  </svg>
</template>
